import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { ProfileService } from '../../core/services/profile.service';
import { Location } from '@angular/common';
import { MatLegacyDialog } from '@angular/material/legacy-dialog';
import { MatDialog } from '@angular/material/dialog';
import { StatusHistoryComponent } from '../statusHistory/statusHistory.component';
import {
  IPhoneModel,
  IStrangerPersonalData,
  IStrangerVehicle,
  IStrangerVehicleOwner,
  IUpdatePersonalContacts,
} from '../../core/models/RegisterStrangerRequest';
import { StrangersType, StrangersOwnerType } from '../../core/shared/enums/strangersType';
import { CountriesResponse } from '../../core/models/country';
import AccountStatus, { getStatusClass } from '../../core/models/account-status.model';
import { TranslocoService } from '@ngneat/transloco';
import { SharedService } from 'src/app/core/services/shared.service';
import IStrangersType from 'src/app/modules/auth/models/interfaces/IStrangersType';
import { CardService } from 'src/app/core/services/card.service';
import { AccountStatusEnum } from 'src/app/core/models/account-status.enum';
import { CodeEnum } from 'src/app/core/shared/enums/codeEnum';
import { MASKS } from 'src/app/core/models/masks.const';
import { ERR_MSG } from 'src/app/core/models/error-messages.const';
import { RegistrationService } from 'src/app/modules/auth/services/registration.service';
import { HttpErrorResponse } from '@angular/common/http';
import { Subscription } from 'rxjs';
import {
  ActivatePhoneDialogComponent,
  IActivatePhoneDialogModel,
} from 'src/app/modules/auth/components/modals/activate-phone-dialog/activate-phone-dialog.component';
import { OkCancelDialogComponent } from '../ok-cancel-dialog/ok-cancel-dialog.component';
import { deepCopy } from 'src/app/core/shared/shared';
import { StrangerProfileInfo } from 'src/app/core/models/strangerProfile';
import { Clipboard } from '@angular/cdk/clipboard';
import { FlashcallTypeEnum } from 'src/app/core/shared/enums/flashcallTypeEnum';
import StrangerAccessPermissions, { IOrganizationInfo } from 'src/app/core/models/stranger-permissions';
import { ErrorCodesEnum } from 'src/app/core/shared/enums/errorCodesEnum';
import { NotificationComponent } from 'src/app/modules/shared/components/notification/notification.component';
import { Router } from '@angular/router';
import AccountUserInfo from 'src/app/core/models/AccountUserInfo';
import { AuthService } from 'src/app/modules/auth/services/auth.service';
import { ConfigService } from 'src/app/modules/client-config/services/config.service';

const RUSSIAN_COUNTRY_CODE_ID = 643;

@Component({
  selector: 'app-profileStrangers',
  templateUrl: './profileStrangers.component.html',
  styleUrls: ['./profileStrangers.component.scss'],
})
export class ProfileStrangersComponent implements OnInit, OnDestroy {
  private subs: Subscription = new Subscription();
  isLoading = true;
  personalData: IStrangerPersonalData = {} as IStrangerPersonalData;
  owner: IStrangerVehicleOwner = {} as IStrangerVehicleOwner;
  vehicleData: IStrangerVehicle = { owner: this.owner } as IStrangerVehicle;
  permissions: StrangerAccessPermissions = {} as StrangerAccessPermissions;

  isShowAttention = true;
  MASKS = MASKS;
  ERR_MSG = ERR_MSG;
  CodeEnum = CodeEnum;
  strangersType = StrangersType;
  strangersOwnerType = StrangersOwnerType;
  typesUser: IStrangersType[];
  strangersOwnerTypes: IStrangersType[];
  countriesAll: CountriesResponse[] = [];
  countriesByClients: CountriesResponse[] = [];
  errorMessage = '';
  typeUserTS: IStrangersType | null = null;
  isMatch = true;
  serverValidationErrors: string[] = [];
  notificationMessage = '';
  isShowNotification = false;
  isSaveSuccess = false;

  showForeignPersonalInn: boolean;
  showStrangersVehicles = false;
  showForeignTaxAuthority: boolean;
  needConfirmPhone = false;
  canEditPersonalContact = false;

  strangerInitData: StrangerProfileInfo = {} as StrangerProfileInfo;
  accType = '';
  accStatusEnum = AccountStatusEnum;
  accStatus: AccountStatus | null = {} as AccountStatus;
  phonePersonal: IPhoneModel = {} as IPhoneModel;

  userInfo: AccountUserInfo | null = null;

  @ViewChild('notification') notification!: NotificationComponent;

  constructor(
    public profileService: ProfileService,
    private registrationService: RegistrationService,
    public sharedService: SharedService,
    private _location: Location,
    private legacyDialog: MatLegacyDialog,
    private dialog: MatDialog,
    private authService: AuthService,
    private cardService: CardService,
    private configService: ConfigService,
    private clipboard: Clipboard,
    private router: Router,
    private translocoService: TranslocoService
  ) {
    this.getCountries();
    this.typesUser = this.sharedService.getStrangersTypes();
    this.strangersOwnerTypes = sharedService.getStrangersOwnerTypes();

    this.showForeignPersonalInn = configService.customization.getOptionBool(CodeEnum.FOREIGN_PERSONAL_INN);
    this.showStrangersVehicles = configService.customization.getOptionBool(CodeEnum.FOREIGN_VEHICLES);
    this.showForeignTaxAuthority = configService.customization.getOptionBool(CodeEnum.FOREIGN_TAX_AUTHORITY);
    this.needConfirmPhone = configService.customization.getOptionBool(CodeEnum.NEED_CONFIRM_PHONE);
  }

  ngOnInit(): void {
    this.getUserInfo();

    this.updateData();
  }

  ngOnDestroy(): void {
    this.subs.unsubscribe();
  }

  getCountries() {
    this.subs.add(
      this.registrationService.getCountry().subscribe((countries) => {
        this.countriesAll = countries;
      })
    );
    this.subs.add(
      this.registrationService.getStrangerCountries([]).subscribe((countries) => {
        this.countriesByClients = countries;
      })
    );
  }

  onChangedPersonalPhone(phone: IPhoneModel): void {
    this.personalData.phone = phone.phoneNumber;
    this.personalData.phoneCountryCode = phone.phoneCountryCode;
  }

  onConfirmPhoneClick() {
    this.subs.add(
      this.dialog
        .open(ActivatePhoneDialogComponent, {
          data: {
            accountId: this.strangerInitData.id,
            phone: this.personalData.phone,
            flashcallType: FlashcallTypeEnum.CONFIRM_PHONE,
            isStranger: true,
          } as IActivatePhoneDialogModel,
          autoFocus: false,
          disableClose: true,
        })
        .afterClosed()
        .subscribe((isSuccess) => {
          if (isSuccess) {
            this.getUserInfo();
            this.updateData();
          }
        })
    );
  }

  private getUserInfo() {
   this.isLoading = true;
    this.subs.add(
      this.authService.getUserInfo()
        .subscribe((result) => {
          this.userInfo = result;
          this.isLoading = false;
        })
    );
  }

  public updateData() {
    this.isLoading = true;
    this.serverValidationErrors = [];

    this.updatePermissions();

    this.subs.add(
      this.profileService.getStranger().subscribe(async (data) => {
        this.isLoading = false;

        this.canEditPersonalContact = !!data.canEditPersonalContact;
        this.strangerInitData = deepCopy(data.data);

        this.personalData = data.data.personalData ?? ({} as IStrangerPersonalData);
        this.phonePersonal = {
          phoneCountryCode: data.data.personalData?.phoneCountryCode,
          phoneNumber: data.data.personalData?.phone,
        } as IPhoneModel;
        this.owner = data.data.vehicleData?.owner;
        if (!!data.data.vehicleData) {
          this.vehicleData = data.data.vehicleData;
          this.typeUserTS = this.strangersOwnerTypes.find((x) => x.id === data.data.vehicleData.ownerType) ?? null;
        }
        this.isMatch = this.vehicleData?.ownerType == StrangersOwnerType.APPLICANT;
        this.accStatus = !!data.actualStatus?.statusId
          ? new AccountStatus(data.actualStatus.statusId, data.actualStatus.name, data.actualStatus.nameEn)
          : null;
        this.accType = data.data.type;

        this.isShowNotification = true;
      })
    );
  }

  get isPhoneConfirmed() {
    return this.userInfo?.isPhoneConfirmed || this.needConfirmPhone;
  }

  get isEmailConfirmed() {
    return this.userInfo?.isEmailConfirmed;
  }

  updatePermissions() {
    this.subs.add(
      this.profileService.getStrangerPermissions().subscribe((response) => {
        this.permissions = response;
      })
    );
  }

  getStatusClass(s: number): string {
    return getStatusClass(s);
  }

  onBack() {
    this._location.back();
  }

  getTypeStrangerName(type: string | undefined) {
    if (!!type) {
      const findType = this.typesUser.find((x) => x.id == type);
      if (!!findType) {
        return this.getActiveLang() == 'ru' ? findType?.name : findType?.inEnglish;
      }
    }
    return '';
  }

  getActiveLang() {
    return this.translocoService.getActiveLang();
  }

  public copyClipboard(text: string | number) {
    this.clipboard.copy(text + '');
  }

  getStatusHistory() {
    this.legacyDialog.open(StatusHistoryComponent, {
      data: true,
      panelClass: 'l',
    });
  }

  sendConfirmMail() {
    this.subs.add(
      this.cardService.sendActivateMail(true).subscribe((res) => {
        this.isShowNotification = true;
      })
    );
  }

  onBeforeInputPhoneNumber(evt: InputEvent) {
    const inputValue = (<HTMLTextAreaElement>evt.target).value;
    const isPlusExist = !!inputValue && inputValue.includes('+');

    if ((evt.inputType !== 'deleteContentBackward' && /[^0-9+]/.test(evt.data || '')) || (isPlusExist && evt.data === '+')) {
      evt.preventDefault();
      return;
    }
  }

  saveClick() {
    if (!this.canSave()) {
      return;
    }
    if (this.isPhoneChanged() || this.isMailChanged()) {
      let fields = '';
      if (this.isMailChanged()) fields = this.translocoService.translate('profileStrangers.email');
      if (this.isPhoneChanged()) fields += (!!fields ? ', ' : '') + this.translocoService.translate('profileStrangers.phoneNumber');

      this.subs.add(
        this.dialog
          .open(OkCancelDialogComponent, {
            data: {
              title: this.translocoService.translate('attention'),
              text: this.translocoService.translate('profileStrangers.changeFieldsNeedConfirmAttention', { fields: fields }),
            },
          })
          .afterClosed()
          .subscribe((isOk: any) => {
            if (isOk) {
              this.submit();
            }
          })
      );
    } else {
      this.submit();
    }
  }

  //почту отредактировали
  isMailChanged(): boolean {
    return this.strangerInitData.personalData?.email != this.personalData?.email;
  }

  //телефон отредактировали
  isPhoneChanged(): boolean {
    return (
      this.needConfirmPhone && this.strangerInitData.personalData?.phone != this.personalData?.phone
    );
  }

  submit() {
    this.serverValidationErrors = [];

    const contacts: IUpdatePersonalContacts = {
      email: this.personalData?.email ?? null,
      phone: this.personalData?.phone?.replace('+', '') ?? null,
      phoneCountryCode: this.personalData?.phoneCountryCode ?? null,
    };

    this.errorMessage = '';
    this.subs.add(
      this.profileService.updatePersonalContacts(contacts).subscribe(
        (response) => {
          if (response) {
            if (response.error == 'user_exist') {
              this.errorMessage = this.translocoService.translate('confirmSuccessInfo.descriptionEmailExist');
            } else if (!!response.error) {
              this.errorMessage = response.error;
            } else {
              this.updateData();
              this.isSaveSuccess = true;
            }
          }
        },
        (err: HttpErrorResponse) => {
          if (err.status === 429) {
            this.serverValidationErrors = [this.translocoService.translate('errorCodes.RATELIMITER')];
          } else if (err.status === 400) {
            let error = '';
            for (const prop in err.error) {
              error += err.error[prop].errorMessage + '\r\n';
            }
            this.serverValidationErrors = [error];
          } else {
            this.serverValidationErrors = [err.error];
          }
        }
      )
    );
  }

  canSave() {
    return (
      !!this.personalData?.email &&
      !!this.personalData?.phone &&
      !!this.personalData?.phoneCountryCode &&
      this.sharedService.isEmailRegular(this.personalData.email)
    );
  }

  // фильтруем список стран и сортируем в зависимости от языка(для русских только одна страна RUSSIAN_COUNTRY_CODE_ID)
  getCountriesList(list: CountriesResponse[], filterText: string): CountriesResponse[] {
    if (this.accType == StrangersType.PERSONRUS || this.accType == StrangersType.ORGANIZATIONRUS) {
      return list.filter((x) => x.id == RUSSIAN_COUNTRY_CODE_ID);
    }

    const isRu = this.getActiveLang() == 'ru';
    return list
      .filter(
        (x) =>
          x.id != RUSSIAN_COUNTRY_CODE_ID &&
          (x.name.toLocaleLowerCase().includes(filterText.toLowerCase()) || x.inEnglish.toLocaleLowerCase().includes(filterText.toLowerCase()))
      )
      .sort((one, two) => ((isRu ? one.name < two.name : one.inEnglish < two.inEnglish) ? -1 : 1));
  }

  isDisableEdit(name: string = '--') {
    // В профиле иностранца редактируются только контактные данные: почта, телефон и код страны телефона
    if (name != 'phone' && name != 'email') return true;

    return !this.isPersonalContactEditable();
  }

  /** Редактирование контактных данных доступно только при отсутствии активных заявок */
  isPersonalContactEditable(): boolean {
    return this.canEditPersonalContact;
  }

  onRegistrationRequestClick() {
    this.updatePermissions();
    this.updateData();
  }

  onSwitchOrganizationClick(item: IOrganizationInfo) {
    this.profileService.changeStrangerRole(item.strangerUserOrganizationId).subscribe((result) => {
      next: {
        if (result.url) {
          if (result.url.startsWith('http://') || result.url.startsWith('https://')) {
            window.location.href = result.url;
          } else {
            this.router.navigate([result.url]);
          }
        }
      }
    });
  }

  onRegisterOrganizationClick() {
    this.updatePermissions();
  }
}
